module.exports = "/images/redArrow.svg";